// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2VTwW","content":"styles_content__208US","checkbox":"styles_checkbox__iiIH3","checkboxLabel":"styles_checkboxLabel__17y-M"};